(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('LabBundleBillingCode', LabBundleBillingCode);

    LabBundleBillingCode.$inject = ['$resource'];

    function LabBundleBillingCode ($resource) {
        var resourceUrl =  'api/lab-bundle-billing-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'init2': { method:'GET', url: 'api/lab-bundle-billing-codes/init'}
        });
    }
})();
